import { createSelector } from 'reselect'
import createSortedCardStatusesSelector from './createSortedCardStatusesSelector'

const createCardStatusSelector = (
  cardIdSelector,
  cardStatusIdsSelector,
) => createSelector<any, any, any, any[]>(
  [
    cardIdSelector,
    state => state['view-board'].cards,
    createSortedCardStatusesSelector(cardStatusIdsSelector),
  ],
  (
    cardId,
    cardsById,
    cardStatuses,
  ) => {
    const card = cardsById[cardId]

    if (!card) return undefined

    const cardStatus = cardStatuses.find(status => status.id === card.statusId)

    if (cardStatus) return cardStatus

    return cardStatuses.find(status => status.isDefault)
  }
)

export default createCardStatusSelector
